<template>
  <a :href="toNishika('/')">
    <v-img v-if="white" width="112px" src="@/assets/nishika_white_horizontal.svg" contain/>
    <v-img v-else width="60px" src="@/assets/logo.svg" contain/>
  </a>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "atom",
    name: "NishikaLogo",
    props: {
      "white": {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style scoped>
</style>
